export function useProductDetailsSlug(slug: string | string[] | undefined) {

    const productId = slug && (slug?.length || 0) > 1 ? slug[2] : '';
    const variantId = slug && (slug?.length || 0) > 1 ? slug[2] : '';

    return {
        productId, variantId
    }
}